import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Pricing = () => {
    const [isMonthlyActive, setIsMonthlyActive] = useState(true);
    const togglePricing = () => {
        setIsMonthlyActive(!isMonthlyActive);
    };
    return (
        <>
            <div className="pricing-section-one">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-6 m-auto">
                            <div className="heading-box text-center">
                                <span className="sub-title-two animate fadeInUp wow" data-wow-duration="1500ms">pricing</span>
                                <h2 className="heading-title animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay="200ms">flexible pricing plans</h2>
                                <p className="lead animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay="400ms">Flexible and affording plans tailored to your needs. Save up to %2 for a limited time.</p>
                            </div>
                            <div className="sweech-box-pricing-one">
                                <p
                                    className={`monthly-pricing ${isMonthlyActive ? 'active' : ''}`}
                                    onClick={togglePricing}
                                >
                                    Monthly
                                </p>
                                <p
                                    className={`yearly-pricing ${!isMonthlyActive ? 'active' : ''}`}
                                    onClick={togglePricing}
                                >
                                    Yearly
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="pricing-box-outer">
                        {isMonthlyActive && (
                            <div className="row monthly-box-one gutter-y-30">
                                <div className="col-lg-4 col-md-6">
                                    <div className="pricing-box-one animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                                        <div className="box-header-one">
                                            <h5>Basic Plan</h5>
                                            <div className="pricing-one">
                                                <h2>$499</h2>
                                                <p>Month</p>
                                            </div>
                                        </div>
                                        <div className="pricing-body">
                                            <ul>
                                                <li>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>Business Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>24/7 Consultant Service</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>Great Customer Support</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>Market Growth Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>24/7 Customer Support</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <Link to="/Contact" className="btn btn-primary btn-block btn-theme">Select this plan <span>+</span></Link>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div
                                        className="pricing-box-one two animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="400ms"
                                    >
                                        <div className="box-header-one">
                                            <h5>Standard Plan</h5>
                                            <div className="pricing-one">
                                                <h2>$599</h2>
                                                <p>Month</p>
                                            </div>
                                        </div>
                                        <div className="pricing-body">
                                            <ul>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Business Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>24/7 Consultant Service</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Great Customer Support</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Market Growth Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>24/7 Customer Support</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <Link to="/Contact"
                                            className="btn btn-primary btn-block btn-theme"
                                        >
                                            Select this plan <span>+</span>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div
                                        className="pricing-box-one animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="600ms"
                                    >
                                        <div className="box-header-one">
                                            <h5>Business Plan</h5>
                                            <div className="pricing-one">
                                                <h2>$699</h2>
                                                <p>Month</p>
                                            </div>
                                        </div>
                                        <div className="pricing-body">
                                            <ul>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Business Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>24/7 Consultant Service</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Great Customer Support</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Market Growth Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>24/7 Customer Support</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <Link to="/Contact"
                                            className="btn btn-primary btn-block btn-theme"
                                        >
                                            Select this plan <span>+</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                        {!isMonthlyActive && (
                            <div className="row yearly-box-one gutter-y-30">
                                <div className="col-lg-4 col-md-6">
                                    <div className="pricing-box-one animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                                        <div className="box-header-one">
                                            <h5>Basic Plan</h5>
                                            <div className="pricing-one">
                                                <h2>$899</h2>
                                                <p>Year</p>
                                            </div>
                                        </div>
                                        <div className="pricing-body">
                                            <ul>
                                                <li>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>Business Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>24/7 Consultant Service</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>Great Customer Support</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>Market Growth Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>24/7 Customer Support</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <Link to="/Contact" className="btn btn-primary btn-block btn-theme">Select this plan <span>+</span></Link>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div
                                        className="pricing-box-one two animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="400ms"
                                    >
                                        <div className="box-header-one">
                                            <h5>Standard Plan</h5>
                                            <div className="pricing-one">
                                                <h2>$999</h2>
                                                <p>Year</p>
                                            </div>
                                        </div>
                                        <div className="pricing-body">
                                            <ul>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Business Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>24/7 Consultant Service</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Great Customer Support</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Market Growth Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>24/7 Customer Support</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <Link to="/Contact"
                                            className="btn btn-primary btn-block btn-theme"
                                        >
                                            Select this plan <span>+</span>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div
                                        className="pricing-box-one animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="600ms"
                                    >
                                        <div className="box-header-one">
                                            <h5>Business Plan</h5>
                                            <div className="pricing-one">
                                                <h2>$1499</h2>
                                                <p>Year</p>
                                            </div>
                                        </div>
                                        <div className="pricing-body">
                                            <ul>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Business Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>24/7 Consultant Service</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Great Customer Support</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>Market Growth Solution</p>
                                                </li>
                                                <li>
                                                    <i className="fa-solid fa-check" />
                                                    <p>24/7 Customer Support</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <Link to="/Contact"
                                            className="btn btn-primary btn-block btn-theme"
                                        >
                                            Select this plan <span>+</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Pricing;
